var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"o-icon",class:[
        ("o-icon--" + _vm.icon),
        _vm.size ? ("o-icon--" + _vm.size) : ''
    ]},[(_vm.fallback)?_c('span',{staticClass:"o-icon__fallback"},[_vm._v("\n        "+_vm._s(_vm.icon.charAt(0).toUpperCase())+"\n    ")]):_c('svg',{class:'svg-' + _vm.icon},[(_vm.title)?_c('title',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('use',{attrs:{"xlink:href":'/assets/svg/sprite.svg#svg-' + _vm.icon}})])])}
var staticRenderFns = []

export { render, staticRenderFns }